import { Component, Input, OnInit, OnChanges, SimpleChanges, SimpleChange, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { InfoSetNames } from 'DiscoveryEngine.TS/InfoSets/InfoSetNames';
import { MenuItem } from 'primeng/api';
import {
	DeviceDto, InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';
import { UserPermissionsService } from 'identity';
import { InfoViewerComponent } from '../info-viewer/info-viewer.component';
import { ConfigurationService } from 'configuration';
import { Subscription } from 'rxjs';
import { InfoSetViewerComponent } from '../infosetviewer/infosetviewer.component';
import { DeviceLayer2MapComponent } from 'topomap';
import { InfoSet } from '../../../DiscoveryEngine.TS/InfoSets/InfoSet';

@Component({
	selector: 'info-sets',
	templateUrl: './infosets.component.html',
	styleUrls: ['./infosets.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoSetsComponent implements OnInit, OnChanges {

	@Input()
	public selectedDevice: DeviceDto;
	public get hasSelectedDevice(): boolean {
		return !!this.selectedDevice;
	}

	@Input()
	public scrollHeight: string = 'calc(90vh - 300px)';

	@Input()
	public isMasterDevice: boolean = false;

	@ViewChild('ifinfo')
	public ifInfoViewer: InfoViewerComponent;

	@ViewChild('bpinfo')
	public bpInfoViewer: InfoViewerComponent;

	@ViewChild('devicemap')
	public deviceMap: DeviceLayer2MapComponent;

	public systemInfo: InfoSetView;
	public ipAddressInfo: InfoSetView;
	public vrrpInfo: InfoSetView;
	public interfaceInfo: InfoSetView;
	public bridgePortInfo: InfoSetView;
	public lagPortInfo: InfoSetView;
	public assetInfo: InfoSetView;
	public linkInfo: InfoSetView;
	public credentialInfo: InfoSetView;
	public vlanInfo: InfoSetView;
	public ipRouteInfo: InfoSetView;
	public arpInfo: InfoSetView;
	public stpPortInfo: InfoSetView;
	public fdbInfo: InfoSetView;
	public cdpInfo: InfoSetView;
	public lldpInfo: InfoSetView;
	public entPhysicalInfo: InfoSetView;
	public installedSoftwareInfo: InfoSetView;
	public win32ComputerSystemInfo: InfoSetView;
	public win32OperatingSystemInfo: InfoSetView;
	public win32BiosInfo: InfoSetView;
	public win32DiskDriveInfo: InfoSetView;
	public win32LogicalDiskInfo: InfoSetView;
	public win32ProcessorInfo: InfoSetView;
	public win32PhysicalMemoryInfo: InfoSetView;
	public win32ProcessInfo: InfoSetView;
	public apInfo: InfoSetView;
	public apIfInfo: InfoSetView;
	public apClientInfo: InfoSetView;
	public virtualHostInfo: InfoSetView;
	public virtualHostTableInfo: InfoSetView;
	public virtualMachineTableInfo: InfoSetView;
	public virtualSwitchTableInfo: InfoSetView;
	public ipPhoneTableInfo: InfoSetView;
	public ipPhoneInfo: InfoSetView;
	public portStatusInfo: InfoSetView;
	public configInfo: InfoSetView;
	public notesInfo: InfoSetView;
	public deviceMapInfo: InfoSetView;

	private infoset_show(infoset_var_name: string): boolean {
		let infoset_loaded = this[infoset_var_name + "_loaded"];
		if (infoset_loaded) {
			return true;
		}

		let infoset_exists = !!this[infoset_var_name];
		let infoset_index = this[infoset_var_name + "_index"];
		if (infoset_exists && (this.activeIndex == infoset_index)) {
			this[infoset_var_name + "_loaded"] = true;
			return true;
		}

		return false;
	}

	public get systemInfo_show(): boolean {
		return this.infoset_show("systemInfo");
	}
	public get ipAddressInfo_show(): boolean {
		return this.infoset_show("ipAddressInfo");
	}
	public get vrrpInfo_show(): boolean {
		return this.infoset_show("vrrpInfo");
	}
	public get interfaceInfo_show(): boolean {
		return this.infoset_show("interfaceInfo");
	}
	public get bridgePortInfo_show(): boolean {
		return this.infoset_show("bridgePortInfo");
	}
	public get lagPortInfo_show(): boolean {
		return this.infoset_show("lagPortInfo");
	}
	public get assetInfo_show(): boolean {
		return this.infoset_show("assetInfo");
	}
	public get linkInfo_show(): boolean {
		return this.infoset_show("linkInfo");
	}
	public get credentialInfo_show(): boolean {
		return this.infoset_show("credentialInfo");
	}
	public get vlanInfo_show(): boolean {
		return this.infoset_show("vlanInfo");
	}
	public get ipRouteInfo_show(): boolean {
		return this.infoset_show("ipRouteInfo");
	}
	public get arpInfo_show(): boolean {
		return this.infoset_show("arpInfo");
	}
	public get stpPortInfo_show(): boolean {
		return this.infoset_show("stpPortInfo");
	}
	public get fdbInfo_show(): boolean {
		return this.infoset_show("fdbInfo");
	}
	public get cdpInfo_show(): boolean {
		return this.infoset_show("cdpInfo");
	}
	public get lldpInfo_show(): boolean {
		return this.infoset_show("lldpInfo");
	}
	public get entPhysicalInfo_show(): boolean {
		return this.infoset_show("entPhysicalInfo");
	}
	public get installedSoftwareInfo_show(): boolean {
		return this.infoset_show("installedSoftwareInfo");
	}
	public get win32ComputerSystemInfo_show(): boolean {
		return this.infoset_show("win32ComputerSystemInfo");
	}
	public get win32OperatingSystemInfo_show(): boolean {
		return this.infoset_show("win32OperatingSystemInfo");
	}
	public get win32BiosInfo_show(): boolean {
		return this.infoset_show("win32BiosInfo");
	}
	public get win32DiskDriveInfo_show(): boolean {
		return this.infoset_show("win32DiskDriveInfo");
	}
	public get win32LogicalDiskInfo_show(): boolean {
		return this.infoset_show("win32LogicalDiskInfo");
	}
	public get win32ProcessorInfo_show(): boolean {
		return this.infoset_show("win32ProcessorInfo");
	}
	public get win32PhysicalMemoryInfo_show(): boolean {
		return this.infoset_show("win32PhysicalMemoryInfo");
	}
	public get win32ProcessInfo_show(): boolean {
		return this.infoset_show("win32ProcessInfo");
	}
	public get apInfo_show(): boolean {
		return this.infoset_show("apInfo");
	}
	public get apIfInfo_show(): boolean {
		return this.infoset_show("apIfInfo");
	}
	public get apClientInfo_show(): boolean {
		return this.infoset_show("apClientInfo");
	}
	public get virtualHostInfo_show(): boolean {
		return this.infoset_show("virtualHostInfo");
	}
	public get virtualHostTableInfo_show(): boolean {
		return this.infoset_show("virtualHostTableInfo");
	}
	public get virtualMachineTableInfo_show(): boolean {
		return this.infoset_show("virtualMachineTableInfo");
	}
	public get virtualSwitchTableInfo_show(): boolean {
		return this.infoset_show("virtualSwitchTableInfo");
	}
	public get ipPhoneTableInfo_show(): boolean {
		return this.infoset_show("ipPhoneTableInfo");
	}
	public get ipPhoneInfo_show(): boolean {
		return this.infoset_show("ipPhoneInfo");
	}
	public get portStatusInfo_show(): boolean {
		return this.infoset_show("portStatusInfo");
	}
	public get configInfo_show(): boolean {
		return this.infoset_show("configInfo");
	}
	public get notesInfo_show(): boolean {
		return this.infoset_show("notesInfo");
	}
	public get deviceMapInfo_show(): boolean {
		return this.infoset_show("deviceMapInfo");
	}

	private static InfoSets: [infoset_var_name: string, infoset_lookup_name: string][] = [
		["systemInfo", InfoSetNames.SystemInfo],
		["ipAddressInfo", InfoSetNames.IpAddressTable],
		["vrrpInfo", InfoSetNames.VrrpTable],
		["interfaceInfo", InfoSetNames.IfTable],
		["bridgePortInfo", InfoSetNames.BridgePortTable],
		["lagPortInfo", InfoSetNames.LagTable],
		["assetInfo", InfoSetNames.AssetTable],
		["linkInfo", "link-info"],
		["credentialInfo", "credential-info"],
		["vlanInfo", InfoSetNames.VlanTable],
		["ipRouteInfo", InfoSetNames.IpRouteTable],
		["arpInfo", InfoSetNames.IfArpTable],
		["stpPortInfo", InfoSetNames.StpPortTable],
		["fdbInfo", InfoSetNames.BridgePortFdbTable],
		["cdpInfo", InfoSetNames.IfCdpTable],
		["lldpInfo", InfoSetNames.PortLldpTable],
		["entPhysicalInfo", InfoSetNames.EntPhysicalTable],
		["installedSoftwareInfo", InfoSetNames.InstalledSoftwareTable],
		["win32ComputerSystemInfo", InfoSetNames.Win32_ComputerSystemInfo],
		["win32OperatingSystemInfo", InfoSetNames.Win32_OperatingSystemInfo],
		["win32BiosInfo", InfoSetNames.Win32_BIOSInfo],
		["win32DiskDriveInfo", InfoSetNames.Win32_DiskDriveTable],
		["win32LogicalDiskInfo", InfoSetNames.Win32_LogicalDiskTable],
		["win32ProcessorInfo", InfoSetNames.Win32_ProcessorTable],
		["win32PhysicalMemoryInfo", InfoSetNames.Win32_PhysicalMemoryTable],
		["win32ProcessInfo", InfoSetNames.Win32_ProcessTable],
		["apInfo", InfoSetNames.ApTable],
		["apIfInfo", InfoSetNames.ApIfTable],
		["apClientInfo", InfoSetNames.ApClientTable],
		["virtualHostInfo", InfoSetNames.VirtualHostInfo],
		["virtualHostTableInfo", InfoSetNames.VirtualHostTable],
		["virtualMachineTableInfo", InfoSetNames.VirtualMachineTable],
		["virtualSwitchTableInfo", InfoSetNames.VirtualSwitchTable],
		["ipPhoneTableInfo", InfoSetNames.IpPhoneTable],
		["ipPhoneInfo", InfoSetNames.IpPhoneInfo],
		["portStatusInfo", InfoSetNames.PortStatusTable],
		["configInfo", InfoSetNames.ConfigInfo],
		["notesInfo", InfoSetNames.NotesInfo],
	];

	private updateInfoSets(): void {

		this.activeIndex = 0;

		let curIndex = 0;
		for (let i = 0; i < InfoSetsComponent.InfoSets.length; ++i) {

			let infoset_var_name = InfoSetsComponent.InfoSets[i][0];
			let infoset_lookup_name = InfoSetsComponent.InfoSets[i][1];
			
			this[infoset_var_name] = this.findInfoSetView(infoset_lookup_name);
			this[infoset_var_name + "_index"] = (!!this[infoset_var_name] ? curIndex++ : undefined);		
			this[infoset_var_name + "_loaded"] = (this[infoset_var_name + "_index"] === this.activeIndex);		
		}

		if (this.hasSelectedDevice) {
			this["deviceMapInfo"] = this.systemInfo;
			this["deviceMapInfo_index"] = curIndex++;
			this["deviceMapInfo_loaded"] = (this.activeIndex === this["deviceMapInfo_index"]);
		}
		else {
			this["deviceMapInfo"] = undefined;
			this["deviceMapInfo_index"] = undefined;
			this["deviceMapInfo_loaded"] = undefined;
		}
	}

	public displayIfAliasUpdateDialog;
	public displayIfEnableDisableDialog;
	public displayIfManagePoeDialog;
	public displayIfJackLookupDialog;
	public displayEditAccessVlansDialog;

	public interfacesCmItems: MenuItem[];
	public bridgePortsCmItems: MenuItem[];

	public deviceGuid: string;
	public deviceName: string;
	public ifIndex: number;

	private onIntegrationTableLoadedSub: Subscription;

	public activeIndex: number;
	
	constructor(private userPemissionsService: UserPermissionsService,
		private changeDetector: ChangeDetectorRef,
		private configService: ConfigurationService) {

		this.displayIfAliasUpdateDialog = false;
		this.displayIfEnableDisableDialog = false;
		this.displayIfManagePoeDialog = false;
		this.displayIfJackLookupDialog = false;
		this.displayEditAccessVlansDialog = false;

		this.onIntegrationTableLoadedSub = this.configService.onIntegrationTableLoaded.subscribe(
			() => {
				this.buildContextMenuItems();
			},
			(error) => {
				this.buildContextMenuItems();
			});

		this.buildContextMenuItems();

		this.deviceGuid = "";
		this.deviceName = "";
		this.ifIndex = -1;

		this.activeIndex = 0;
	}

	private buildContextMenuItems(): void {
		this.interfacesCmItems = [
			{ label: "Alias Update...", command: (event) => this.onIfAliasUpdate(event) },
			{ label: "Enable/Disable...", command: (event) => this.onIfEnableDisable(event) },
			{ label: "Manage POE...", command: (event) => this.onIfManagePoe(event) },
		];

		if (this.userPemissionsService.canViewJackLookup) {
			this.interfacesCmItems.push({ label: "Jack Lookup...", command: (event) => this.onIfJackLookup(event) });
		}

		this.bridgePortsCmItems = [
			{ label: "Edit Access VLANs...", command: (event) => this.onEditAccessVlans(event) },
		];
	}

	public ngOnInit(): void {
		
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["selectedDevice"]) {

			this.deviceGuid = "";
			if (this.hasSelectedDevice) {
				this.deviceGuid = this.selectedDevice.deviceGuid;
			}

			this.deviceName = "";
			if (this.hasSelectedDevice) {
				this.deviceName = this.selectedDevice.displayName;
			}

			this.updateInfoSets();
		}
	}

	public ngOnDestroy(): void {
		this.onIntegrationTableLoadedSub?.unsubscribe();
		this.onIntegrationTableLoadedSub = undefined;
	}

	public onResize(entries: any): void {
		if (this.deviceMap) {
			this.deviceMap.onResize(entries);
		}
	}

	public patchData(newDevice: DeviceDto): void {
		if (this.ifInfoViewer) {
			let ifInfo = this.findInfoSetView_2(newDevice, InfoSetNames.IfTable);
			if (ifInfo) {
				this.ifInfoViewer.patchData(ifInfo);
				this.changeDetector.markForCheck();
			}
		}
		if (this.bpInfoViewer) {
			let bpInfo = this.findInfoSetView_2(newDevice, InfoSetNames.BridgePortTable);
			if (bpInfo) {
				this.bpInfoViewer.patchData(bpInfo);
				this.changeDetector.markForCheck();
			}
		}
	}

	public get canViewDeviceConfigs(): boolean {
		return this.userPemissionsService.canViewDeviceConfigs;
	}

	private findInfoSetView(infoSetName: string): InfoSetView {
		if (this.selectedDevice) {
			for (let i = 0; i < this.selectedDevice.infoSets.length; ++i) {
				let infoSet = this.selectedDevice.infoSets[i];
				if (infoSet.infoSetName === infoSetName) {
					return infoSet;
				}
			}
		}
		return null;
	}

	private findInfoSetView_2(device: DeviceDto, infoSetName: string): InfoSetView {
		for (let i = 0; i < device.infoSets.length; ++i) {
			let infoSet = device.infoSets[i];
			if (infoSet.infoSetName === infoSetName) {
				return infoSet;
			}
		}
		return null;
	}

	private onIfAliasUpdate(event: any) {
		this.ifIndex = this.ifInfoViewer.selection.ifIndexTag;
		this.displayIfAliasUpdateDialog = true;
	}

	private onIfEnableDisable(event: any) {
		this.ifIndex = this.ifInfoViewer.selection.ifIndexTag;
		this.displayIfEnableDisableDialog = true;
	}

	private onIfManagePoe(event: any) {
		this.displayIfManagePoeDialog = true;
	}

	private onIfJackLookup(event: any) {
		this.displayIfJackLookupDialog = true;
	}

	private onEditAccessVlans(event: any) {
		this.displayEditAccessVlansDialog = true;
	}
}
